module.exports = __webpack_public_path__ + "static/media/deal.16e9d747.png";